import isNextLink from './stringifyUrl';

export default isNextLink;
